if (!customElements.get('td-klaviyo-waitlist')) {
  const WAITLIST_SELECTORS = {
    trigger: '[data-td-waitlist-trigger]',
  };

  /** Opens the configured Klaviyo custom-trigger form. */
  class TdKlaviyoWaitlist extends HTMLElement {
    /**
     * Connects the waitlist trigger.
     * @returns {void}
     */
    connectedCallback() {
      this.trigger = this.querySelector(WAITLIST_SELECTORS.trigger);
      this.handleClick = this.openForm.bind(this);
      if (this.trigger) this.trigger.addEventListener('click', this.handleClick);
    }

    /**
     * Disconnects the waitlist trigger.
     * @returns {void}
     */
    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener('click', this.handleClick);
    }

    /**
     * Queues the configured form through Klaviyo's onsite API.
     * @returns {void}
     */
    openForm() {
      const formId = this.trigger?.getAttribute('data-td-waitlist-form-id');
      if (!formId) return;

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }
  }

  customElements.define('td-klaviyo-waitlist', TdKlaviyoWaitlist);
}
